import { render, staticRenderFns } from "./colipays-summary-by-product-type.vue?vue&type=template&id=494b4462&"
import script from "./colipays-summary-by-product-type.vue?vue&type=script&lang=js&"
export * from "./colipays-summary-by-product-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports